(function () {
  const klaviyoForms = document.querySelectorAll('[class^="klaviyo-form-"]');
  const loadingIcons = document.querySelectorAll("[data-klaviyo-loader]");

  if (klaviyoForms.length !== 0) {
    klaviyoForms.forEach((klaviyoForm) => {
      loadingIcons.forEach((loadingIcon) => {
        loadingIcon.classList.add("show");
      });
      setTimeout(() => {
        if (!klaviyoForm.classList.contains("klaviyo-form")) {
          const klaviyoMsgBox = klaviyoForm.nextElementSibling;
          klaviyoMsgBox.classList.add("show");
          klaviyoMsgBox.classList.remove("hide");
          loadingIcons.forEach((loadingIcon) => {
            loadingIcon.classList.remove("show");
          });
        }
      }, 3000);
    });
  }
  setTimeout(() => {
    loadingIcons.forEach((loadingIcon) => {
      loadingIcon.classList.remove("show");
    });
  }, 3000);
})();
